import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";

import ListViewTable from "../../listview/components/ListViewTable";
import { ListTablePolicyShape } from "../../listview/proptypes";
import listTableSelectors from "../../listview/selectors";
import { groups, roles, users } from "../../policies/actions";
import Loader from "../../shared/components/Loader";
import {
  DEFAULT_TABLE_ROW_HEIGHT,
  MIN_WIDTH_ENTITIES,
  MIN_WIDTH_ROLES
} from "../../shared/constants";
import SettingsForm from "./SettingsForm";

const columns = [
  { label: "ID", key: "entity", minWidth: MIN_WIDTH_ENTITIES },
  { label: "Role", key: "role", minWidth: MIN_WIDTH_ROLES }
];

const orderBy = ["entity", "role"];

class Settings extends Component {
  title = "RBAC - Settings";

  openRoles = uri => {
    const { setCurrentRole, push } = this.props;
    setCurrentRole(uri);
    push("/settings/roles");
  };

  render() {
    const { policies, loading } = this.props;
    const containerStyle = {
      height:
        policies.length > 10
          ? "500px"
          : `${(policies.length + 2) * DEFAULT_TABLE_ROW_HEIGHT}px`
    };

    return (
      <div className="l-settings">
        <DocumentTitle title={this.title} />
        <h4 className="l-settings__title">
          Canonical RBAC global administrators
        </h4>
        <div className="l-settings__table-container">
          {loading ? (
            <Loader text="Loading RBAC admins..." />
          ) : (
            <ListViewTable
              columns={columns}
              orderBy={orderBy}
              policies={policies}
              showActions={false}
              openRoles={this.openRoles}
              style={containerStyle}
              parentUrl="/settings"
            />
          )}
        </div>
        <SettingsForm />
      </div>
    );
  }
}

Settings.propTypes = {
  push: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  policies: PropTypes.arrayOf(ListTablePolicyShape).isRequired,
  setCurrentRole: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  policies: listTableSelectors.getAdmins(state),
  loading: state.policies.loading
});

const mapDispatchToProps = {
  setCurrentGroup: groups.setCurrent,
  setCurrentRole: roles.setCurrent,
  setCurrentUser: users.setCurrent,
  push
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);
